import React, { useState } from "react";
import PropTypes from 'prop-types';
import styles from "./EvrNumberToolbar.module.css";
import MonthPicker from "../MonthPicker/MonthPicker";
import { callFunctionConditionallyWithWarningCurry, getMonthNameWithYear } from "../../utils/utils";


const EvrNumberToolbar = ({plantName,handleMonthSelect}) => {
  return (
    <>
      <div className={styles.RgtTools}>
        <div className={styles.eAgsnToolbar}>
        <MonthPicker
        handleSelect={callFunctionConditionallyWithWarningCurry(
          handleMonthSelect,
        )}
      />
          <div className={styles.plantName}>Selected Plant - {plantName}</div>
        </div>
      </div>
    </>
  );
};

EvrNumberToolbar.prototype={
    handleMonthSelect: PropTypes.func,
}

export default EvrNumberToolbar;
